var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnhancedBusiness1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2360_6519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110 28H56V26H52V28H48C48 16.96 39.06 8 28 8C27.8 8 27.58 8 27.38 8C16.58 8.4 8.02 17.26 8 28.08C8.02 34.32 10.98 40.2 16 43.94V102H2C0.9 102 0 102.9 0 104V110C0 115.52 4.48 120 10 120H94C99.52 120 104 115.52 104 110V54H118C119.1 54 120 53.1 120 52V38C120 32.48 115.52 28 110 28ZM12 28.06C12 19.42 18.86 12.32 27.5 12H28C36.82 12 44 19.14 44.02 27.96C44.02 33.38 41.28 38.44 36.72 41.4C35.02 42.5 34 44.38 34 46.4V50H22V46.4C22 46.26 21.96 46.14 21.96 46H30V42H20C19.78 41.78 19.56 41.6 19.3 41.42C14.76 38.5 12 33.46 12 28.06ZM32 54C32 56.2 30.2 58 28 58C25.8 58 24 56.2 24 54H32ZM10 116C6.68 116 4 113.32 4 110V106H84V110C84 112.18 84.72 114.28 86.06 116H10ZM100 38V110C100 113.32 97.32 116 94 116C90.68 116 88 113.32 88 110V104C88 102.9 87.1 102 86 102H20V54C20 58.42 23.58 62 28 62C32.42 62 36 58.42 36 54V53.44C37.24 52.74 38 51.42 38 50V46.4C38 45.72 38.34 45.1 38.92 44.74C43.4 41.82 46.52 37.24 47.56 32H102.06C100.74 33.72 100.02 35.82 100 38ZM116 50H104V38C104 34.68 106.68 32 110 32C113.32 32 116 34.68 116 38V50Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 26H0V30H4V26Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.21801 38.275L2.75391 40.275L4.75391 43.7391L8.21801 41.7391L6.21801 38.275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2434 12.2583L47.7793 14.2583L49.7793 17.7224L53.2434 15.7224L51.2434 12.2583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2734 2.76094L38.2734 6.22504L41.7375 8.22504L43.7375 4.76094L40.2734 2.76094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 0H26V4H30V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7229 2.75378L12.2588 4.75378L14.2588 8.21789L17.7229 6.21789L15.7229 2.75378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7949 38.2764L47.7949 41.7405L51.259 43.7405L53.259 40.2764L49.7949 38.2764Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75879 12.2821L2.75879 15.7462L6.22289 17.7462L8.22289 14.2821L4.75879 12.2821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 76H30C28.9 76 28 76.9 28 78V96C28 97.1 28.9 98 30 98H38C39.1 98 40 97.1 40 96V78C40 76.9 39.1 76 38 76ZM36 94H32V80H36V94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 70H48C46.9 70 46 70.9 46 72V96C46 97.1 46.9 98 48 98H56C57.1 98 58 97.1 58 96V72C58 70.9 57.1 70 56 70ZM54 94H50V74H54V94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 64H66C64.9 64 64 64.9 64 66V96C64 97.1 64.9 98 66 98H74C75.1 98 76 97.1 76 96V66C76 64.9 75.1 64 74 64ZM72 94H68V68H72V94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92 58H84C82.9 58 82 58.9 82 60V96C82 97.1 82.9 98 84 98H92C93.1 98 94 97.1 94 96V60C94 58.9 93.1 58 92 58ZM90 94H86V62H90V94Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6797 50.5L32.6797 64.5L35.3197 67.5L50.4797 54.22L69.4197 59.9C70.1197 60.12 70.8797 59.9 71.3997 59.4L80.8197 50H87.9997C88.6997 50 89.3597 49.64 89.7197 49.02L94.0997 41.72L96.3397 45.08L99.6597 42.86L95.6597 36.86C95.2997 36.3 94.6797 35.98 93.9997 35.98H85.9997V39.98H90.4597L86.8597 45.98H79.9997C79.4597 45.98 78.9597 46.2 78.5797 46.56L69.4197 55.72L50.5597 50.06C49.8997 49.86 49.1797 50.02 48.6597 50.48L48.6797 50.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2360_6519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnhancedBusiness1);
export default __webpack_public_path__ + "static/media/enhanced-business1.fecb40dbe3b7d4765d43a855d1886dfd.svg";
export { ForwardRef as ReactComponent };